// navhbar展示类型
const NavbarShowType = {
  Home: 1, // 首页
  Category: 2, // 分类
  ProductList: 2, // 商品列表
  ProductDetails: 3, // 商品详情
  ProductSearchList: 4, // 商品搜索列表
  MessageCenter: 5, // 消息中心
  Home_Slide: 6, // Home滑动状态
  ProductDetails_Slide: 7, // 商品详情滑动状态
  NewProductList: 8, // 新品抢购列表
  ArrivingSoonList: 9, // 即将到货
  ActivityView: 10 // 活动专区
}

export {
  NavbarShowType
}
